import axios from "axios";
import { Cookies } from "react-cookie";
import config from "../config";
var cookies = new Cookies();

export default axios.create({
  baseURL: config.api.private.baseUrl,
  headers: {
    "x-api-key": config.api.private.headers.apikey,
    "x-client-fingerprint": cookies.get("fingerprint"),
  },
});
